const isDateLessThanToday = (inputDate: string, compareDate = "") => {
  const dateObj1 = new Date(inputDate);
  const dateObj2 = compareDate ? new Date(compareDate) : new Date();
  return dateObj1 < dateObj2;
};

export default isDateLessThanToday;
